module.exports = __webpack_public_path__ + "img/row1_col1_vtac.141e7a7e.svg";